import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app//shared.service';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { zip } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-transporte-aereo',
    templateUrl: './transporte-aereo.component.html',
    styleUrls: ['./transporte-aereo.component.scss']
})
export class TransporteAereoComponent implements OnInit {
    @Input() idOperacion : any;
    @Input() idTransporteAereo : any;
    @Input() dataTransporteAereo : any;
    
    paises;
    PermSCTList;
    taereos: any[] = [];
    codigosTransportista: any[] = [];
    rfcPattern = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
    FormTransporte = new FormGroup({
        transporte: new FormControl(''),
        PermSCT: new FormControl('', [Validators.required]),
        NumPermisoSCT: new FormControl('', [Validators.required]),
        MatriculaAeronave: new FormControl('', [Validators.required]),
        NumeroGuia: new FormControl('', [Validators.required]),
        NombreAseg: new FormControl(''),
        NumPolizaSeguro: new FormControl(''),
        LugarContrato: new FormControl(''),
        CodigoTransportista: new FormControl('', [Validators.required]),
        //Segunda parte
        RFCTransportista: new FormControl('', [Validators.pattern(this.rfcPattern)]),
        NombreTransportista: new FormControl(''),
        ResidenciaFiscalTranspor: new FormControl(''),
        NumRegIdTribTranspor: new FormControl(''),
        RFCEmbarcador: new FormControl('', [Validators.pattern(this.rfcPattern)]),
        NombreEmbarcador: new FormControl(''),
        ResidenciaFiscalEmbarc: new FormControl(0),
        NumRegIdTribEmbarc: new FormControl(''),
    });
    constructor(
        private readonly store: Store<AppState>,
        private srvcoal: CoalService,
        private sharedService: SharedService,
        private _snackBar: MatSnackBar
    ) { }

    async ngOnInit(): Promise<void> {
        await this.selTransportes();
        this.selAereo();
        this.FormTransporte.valueChanges.subscribe(changes => {
            // Realiza las acciones necesarias con los cambios en los campos del formulario
            if (this.FormTransporte.valid) {
                console.log("Validacion : ", this.FormTransporte.value);
                this.sharedService.setFormAereos(changes);
            }
        });

        if(this.idTransporteAereo){
            console.log('Es actualizacion', this.dataTransporteAereo)
            this.FormTransporte.patchValue({
                PermSCT: this.dataTransporteAereo.PermSCT,
                NumPermisoSCT: this.dataTransporteAereo.NumPermisoSCT,
                MatriculaAeronave: this.dataTransporteAereo.MatriculaAeronave,
                NumeroGuia: this.dataTransporteAereo.NumeroGuia,
                NombreAseg: this.dataTransporteAereo.NombreAseg,
                NumPolizaSeguro: this.dataTransporteAereo.NumPolizaSeguro,
                LugarContrato: this.dataTransporteAereo.LugarContrato,
                CodigoTransportista: this.dataTransporteAereo.CodigoTransportista,
                RFCTransportista: this.dataTransporteAereo.RFCTransportista,
                NombreTransportista: this.dataTransporteAereo.NombreTransportista,
                ResidenciaFiscalTranspor: this.dataTransporteAereo.ResidenciaFiscalTranspor,
                NumRegIdTribTranspor: this.dataTransporteAereo.NumRegIdTribTranspor,
                RFCEmbarcador: this.dataTransporteAereo.RFCEmbarcador,
                NombreEmbarcador: this.dataTransporteAereo.NombreEmbarcador,
                ResidenciaFiscalEmbarc: parseInt(this.dataTransporteAereo.ResidenciaFiscalEmbarc),
                NumRegIdTribEmbarc: this.dataTransporteAereo.NumRegIdTribEmbarc,
            });
              
        }
    }

    selTransportes() {
        this.store.dispatch(MostrarSpinner());
        zip(
            this.srvcoal.getService('cat-perm-scts'),
            this.srvcoal.getService('dir-paises?pagination[start]=0&pagination[limit]=54000'),
            this.srvcoal.getService('cat-codigo-trans-aereos')
        ).subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.PermSCTList = res[0]?.data;
            this.paises = res[1]?.data;
            this.codigosTransportista = res[2]?.data;
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        })
        // let data;
        // this.srvcoal.postService('catalogo/PostSelFormstransportes', data).subscribe(
        //     (res: any) => {
        //         if (res.err) {
        //             this.store.dispatch(
        //                 MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
        //             );
        //         } else if (res.excepcion) {
        //             this.store.dispatch(
        //                 MostrarExcepcion({
        //                     pila: res.excepcion,
        //                     tipoExcepcion: 3,
        //                 })
        //             );
        //         } else {
        //             this.paises = res.recordsets[0];
        //             this.PermSCTList = res.recordsets[1];
        //             this.store.dispatch(OcultarSpinner());
        //         }
        //     },
        //     (error: any) => {
        //         this.store.dispatch(
        //             MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        //         );
        //         this.store.dispatch(OcultarSpinner());
        //     }
        // );
    }

    onSelectOption(tipo, data) {
        // if (tipo == 1 && data == 143) {
        //     this.FormTransporte.controls['NumRegIdTribTranspor'].disable();
        //     this.FormTransporte.controls.NumRegIdTribTranspor.setValue("");
        // }
        // if (tipo == 2 && data == 143) {
        //     this.FormTransporte.controls['NumRegIdTribEmbarc'].disable();
        //     this.FormTransporte.controls.NumRegIdTribEmbarc.setValue("");
        // }
    }

    selAereo() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`ope-empresas?filters[id]=${this.idOperacion}&populate[fac_porte_aereos][populate]=*`)
        .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.taereos = [{
                id: 0,
                attributes: {
                    numPermisoSCT: 'Agregue nuevo transporte aéreo'
                }
            }]
            this.taereos = this.taereos.concat(res.data[0].attributes?.fac_porte_aereos?.data
                .sort((a,b) => new Date(b.attributes?.updatedAt).getTime()-new Date(a.attributes?.updatedAt).getTime()));
            this.taereos.length > 1 ?
                (this.asignTransport(this.taereos[1].id), this.FormTransporte.controls.transporte.setValue(this.taereos[1].id)) : '';
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this._snackBar.open("Ocurrió un error al obtener los transportes aéreos guardadod", "OK", {duration: 5000});
        })
        // let data = {
        //     idOperacion: this.idOperacion
        // };
        // this.srvcoal.postService('catalogo/PostSelTransportes', data).subscribe(
        //     (res: any) => {
        //         if (res.err) {
        //             this.store.dispatch(
        //                 MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
        //             );
        //         } else if (res.excepcion) {
        //             this.store.dispatch(
        //                 MostrarExcepcion({
        //                     pila: res.excepcion,
        //                     tipoExcepcion: 3,
        //                 })
        //             );
        //         } else {
                    
        //         }
        //     },
        //     (error: any) => {
        //         this.store.dispatch(
        //             MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        //         );
        //         this.store.dispatch(OcultarSpinner());
        //     }
        // );
    }

    saveTransporte() {
        this.FormTransporte.markAllAsTouched();
        if (!this.FormTransporte.valid) {
            this._snackBar.open("Favor de completar los campor requeridos", "OK", {duration: 10000});
            return;
        }
        let data = {
            data: {
                cat_perm_sct: this.FormTransporte.controls.PermSCT.value,
                numPermisoSCT: this.FormTransporte.controls.NumPermisoSCT.value,
                matriculaAeronave: this.FormTransporte.controls.MatriculaAeronave.value,
                numeroGuia: this.FormTransporte.controls.NumeroGuia.value,
                nombreAseg: this.FormTransporte.controls.NombreAseg.value,
                numPolizaSeguro: this.FormTransporte.controls.NumPolizaSeguro.value,
                lugarContrato: this.FormTransporte.controls.LugarContrato.value,
                cat_codigo_trans_aereo: this.FormTransporte.controls.CodigoTransportista.value,
                rfcTransportista: this.FormTransporte.controls.RFCTransportista.value,
                nombreTransportista: this.FormTransporte.controls.NombreTransportista.value,
                residenciaFiscalTranspor: this.FormTransporte.controls.ResidenciaFiscalTranspor.value,
                numRegIdTribTranspor: this.FormTransporte.controls.NumRegIdTribTranspor.value,
                rfcEmbarcado: this.FormTransporte.controls.RFCEmbarcador.value,
                nombreEmbarcador: this.FormTransporte.controls.NombreEmbarcador.value,
                residenciaFiscalEmbarc: this.FormTransporte.controls.ResidenciaFiscalEmbarc.value,
                numRegIdTribEmbarc: this.FormTransporte.controls.NumRegIdTribEmbarc.value
            }
        }
        this.store.dispatch(MostrarSpinner());
        if (this.FormTransporte.controls.transporte.value) {
            this.srvcoal.putService(`fac-porte-aereos/${this.FormTransporte.controls.transporte.value}`, data)
            .subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.selAereo();
                this._snackBar.open("Transporte aéreo actualizado correctamente", "OK", {duration: 5000});
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this._snackBar.open(`Ocurrió un error al guardar el transporte aéreo ${error?.error?.error?.message}`, "OK", {duration: 18000});
            })
        } else {
            this.srvcoal.postService('fac-porte-aereos', data).subscribe(
                (res: any) => {
                    this.srvcoal.putService(`ope-empresas/${this.idOperacion}`, {
                        data: {
                            fac_porte_aereos: {
                                connect: [res.data?.id]
                            }
                        }
                    }).subscribe((por: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this.selAereo();
                        this._snackBar.open("Transporte aéreo guardado correctamente", "OK", {duration: 5000});
                    }, (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this._snackBar.open(`Ocurrió un error al guardar el transporte aéreo ${error?.error?.error?.message}`, "OK", {duration: 18000})
                    })
                }, (err: any) => {
                    this.store.dispatch(OcultarSpinner());
                    this._snackBar.open(`Ocurrió un error al guardar el transporte aéreo ${err?.error?.error?.message}`, "OK", {duration: 18000})
                }
            )
        }
    }

    deleteTransporte() {
        this.store.dispatch(MostrarSpinner());
        // this.srvcoal.deleteService('fac-porte-aereos/', this.FormTransporte.controls.transporte.value)
        // .subscribe((res: any) => {
        //     this.store.dispatch(OcultarSpinner())
        //     this.FormTransporte.reset();
        //     this.selAereo();
        //     this._snackBar.open('Transporte aéreo eliminado correctamente', "OK", {duration: 5000})
        // }, (error: any) => {
        //     this.store.dispatch(OcultarSpinner())
        //     this._snackBar.open(`Ocurrió un error al eliminar el transporte aéreo. ${error?.error?.error?.message}`, "OK", {duration: 12000});
        // })
    }

    asignTransport(val) {
        if (val == 0) {
            this.FormTransporte.reset();
            this.FormTransporte.markAsUntouched();
        } else {
            let value = this.taereos.find(x => x.id == val)?.attributes;
            this.FormTransporte.controls.CodigoTransportista.setValue(value.cat_codigo_trans_aereo?.data?.id);
            this.FormTransporte.controls.LugarContrato.setValue(value.lugarContrato);
            this.FormTransporte.controls.MatriculaAeronave.setValue(value.matriculaAeronave);
            this.FormTransporte.controls.NombreAseg.setValue(value.nombreAseg);
            this.FormTransporte.controls.NombreEmbarcador.setValue(value.nombreEmbarcador);
            this.FormTransporte.controls.NombreTransportista.setValue(value.nombreTransportista);
            this.FormTransporte.controls.NumPermisoSCT.setValue(value.numPermisoSCT);
            this.FormTransporte.controls.NumPolizaSeguro.setValue(value.numPolizaSeguro);
            this.FormTransporte.controls.NumRegIdTribEmbarc.setValue(value.numRegIdTribEmbarc);
            this.FormTransporte.controls.NumRegIdTribTranspor.setValue(value.numRegIdTribTranspor);
            this.FormTransporte.controls.NumeroGuia.setValue(value.numeroGuia);
            this.FormTransporte.controls.PermSCT.setValue(value.cat_perm_sct?.data?.id);
            this.FormTransporte.controls.RFCEmbarcador.setValue(value.rfcEmbarcado);
            this.FormTransporte.controls.RFCTransportista.setValue(value.rfcTransportista);
            this.FormTransporte.controls.ResidenciaFiscalEmbarc.setValue(value.residenciaFiscalEmbarc?.data?.id);
            this.FormTransporte.controls.ResidenciaFiscalTranspor.setValue(value.residenciaFiscalTranspor?.data?.id);
        }
    }
}
